// From the API
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useFetchNumberOfMetadataMutation } from 'services/api';

// Custom Hook to fetch the projects
function useFetchNumberOfMetadata(projects, activeProject) {

    // Utils
    const user = useSelector((state) => state.persistedReducer.user);
    const token = useSelector((state) => state.persistedReducer.token);
    const [ fetchNumberOfMetadata ] = useFetchNumberOfMetadataMutation();

    // State
    const [numberOfMetadata, setNumberOfMetadata] = useState(0);
    const [metadataCompletedList, setMetadataCompletedList] = useState([]);
    const [refreshIndex, setRefreshIndex] = useState(0);
    const [loading, setLoading] = useState(false);

    // Function to refresh the number of metadata
    const refreshNumberOfMetadata = () => {
        setRefreshIndex((prevRefreshIndex) => prevRefreshIndex + 1);
    };

    useEffect(() => {
        // Function to update the metadata
        const fetchNumber = async () => {
            setLoading(true);
            try {
                const projectObject = projects[activeProject];
                const projectName = Object.keys(projectObject)[0];

                // Get the number of metadata files in the directory
                const response = await fetchNumberOfMetadata({ token: token, requestBody: { email: user, projectName: projectName } }).unwrap();
                if (response.success) {
                    setNumberOfMetadata(response.number);
                    setMetadataCompletedList(response.completedList);
                } else {
                    console.log('Error updating metadata');
                }
            } catch (error) {
                console.log('Error updating metadata');
            }
            setLoading(false);
        };
        if (projects.length > 0){
            fetchNumber();
        }
    }, [projects, activeProject, refreshIndex]); // eslint-disable-line react-hooks/exhaustive-deps

    return { numberOfMetadata, metadataCompletedList, refreshNumberOfMetadata, loading };
}

export default useFetchNumberOfMetadata;